import { Button, Form, Input } from "antd";
import { UserOutlined, MobileOutlined, MailOutlined } from '@ant-design/icons';
import React from "react";
import { Redirect } from "react-router-dom";
import { Core } from "../../components/infrastructure/core";
import { Captcha } from "../../components/captcha";
import { IResult } from "../../components/infrastructure/models";
import AppContext from "../../components/infrastructure/appContext";
import SimplePage from "../../home/simplePage";

interface IChangecontactState {
    success?: boolean;
    loading?: boolean;
    userName?: string;
    phone?: string;
}

export const ChangeContact = () => {
    const { params } = React.useContext(AppContext);
    const [state, setState] = React.useState<IChangecontactState>({ success: false, userName: params['username'], phone: params['phone'] === "null" ? null : params['phone']});
    const [form] = Form.useForm();

    const componentWillUnmount = React.useRef(false);

    const onFinish = async (values: any) => {
        if (state.loading)
            return;

        setState({ ...state, loading: true })
        let response = await fetch("api/userpolicyholder/changecontact", {
            method: 'POST',
            body: JSON.stringify({
                nationalCode: values['nationalcode'],
                equipmentSerialNo: values['equipmentserialno'],
                newPhoneNumber: values['phonenumber'],
                newEmail: values['email'],
                captcha: values['captcha']
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        if (componentWillUnmount.current)
            return;

        if (response.status === 200) {
            let result: IResult = await response.json();
            if (!result.ValidationState.Successful) {
                Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
                setState({ ...state, loading: false });
            }
            else {
                Core.successNotification('شماره موبایل بیمه گزار/مشتری با موفقیت ویرایش شد');
                setState({ ...state, phone: values['phonenumber'], loading: false, success: true });
            }
        }
        else {
            setState({ ...state, loading: false });
        }
    };

    React.useEffect(() => {
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    if (state.success) {
        const phone = state.phone ? (state.phone.substring(0, 4) + "***" + state.phone.substring(7, 11)) : null;
        return <Redirect to={{ pathname: "/login", search: '?username=' + state.userName + '&phone=' + phone + '&phonenotdefined=' + !phone}} />;
    }

    return (
        <SimplePage>
            <div className="box box-blue" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                <img src={'/userlogo.png'} style={{ marginTop: 20, width: 80 }} alt="" />
                <p className="" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 18, fontWeight: "bold", color: "antiquewhite" }}>تغییر شماره موبایل یا ایمیل</p>
            </div>
            <Form
                form={form}
                //labelCol={{ span: 6 }}
                wrapperCol={{ span: 24 }}
                name="normal_login"
                className="box login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50, paddingTop: 5, border: "1px solid white", backgroundColor: "#fefefe90", borderBottomLeftRadius: 15, borderBottomRightRadius: 15, width: "100%", textAlign: "right" }}
                onReset={() => {
                    setState({ ...state, success: true });
                }}
            >
                <Form.Item
                    name="nationalcode"
                    //label="کد ملی"
                    rules={[{
                        required: true,
                        validator: () => {
                            const userName = form.getFieldValue('nationalcode');
                            if (userName === "" || !userName)
                                return Promise.reject(new Error('کد ملی الزامی است'));
                            if (!Core.isNationalCode(userName))
                                return Promise.reject(new Error('کد ملی معتبر نمی باشد'));
                            return Promise.resolve();
                        }
                    }]}
                    initialValue={state.userName ?? ''}
                >
                    <Input
                        disabled={!!state.userName}
                        autoComplete="off"
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="نام کاربری"
                    />
                </Form.Item>

                <Form.Item
                    name="equipmentserialno"
                    //label="سریال (IMEI) دستگاه"
                    rules={[{ required: true, message: 'لطفا سریال دستگاه(IMEI)  را وارد نمایید' }]}
                >
                    <Input
                        placeholder="(IMEI) سریال دستگاه"
                        style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                    name="phonenumber"
                    //label="شماره موبایل"
                    rules={[
                        { len: 11, message: 'شماره موبایل باید 11 رقم باشد' },
                        {
                            validator: () => {
                                const emergencyCallNumber = form.getFieldValue('phonenumber');
                                const email = form.getFieldValue('email');
                                if (!email && !emergencyCallNumber)
                                    return Promise.reject(new Error('شماره موبایل یا آدرس ایمیل را وارد نمایید'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input
                        placeholder="شماره موبایل جدید"
                        style={{ width: "100%" }}
                        type="text"
                        prefix={<MobileOutlined className="site-form-item-icon" />}
                        onKeyPress={(event: any) => {
                            if (event.charCode < 48 || event.charCode > 57) {
                                event.preventDefault();
                            }
                        }}
                        maxLength={11}
                    />

                </Form.Item>
                <Form.Item
                    name="email"
                    //label="آدرس ایمیل"
                    rules={[
                        {
                            validator: () => {
                                const emergencyCallNumber = form.getFieldValue('phonenumber');
                                const email = form.getFieldValue('email');
                                if (!email && !emergencyCallNumber)
                                    return Promise.reject(new Error('شماره موبایل یا آدرس ایمیل را وارد نمایید'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input
                        placeholder="آدرس ایمیل جدید"
                        style={{ width: "100%" }}
                        type="email"
                        prefix={<MailOutlined className="site-form-item-icon" />}
                    />

                </Form.Item>

                {!state.loading &&
                    <Captcha
                        form={form}
                        name="captcha"
                        label="متن تصویر"
                    />
                }

                <Form.Item
                    style={{ direction: 'ltr', textAlign: 'justify' }}
                >
                    <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading} >
                        ثبت
                    </Button>
                    <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading}>
                        لغو
                    </Button>
                </Form.Item>
            </Form>
        </SimplePage>
    );
}
